/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type WebhookDataNetworkIDUpdated = {
  accountID: string;
  visaMid?: string | undefined;
  mastercardMid?: string | undefined;
  discoverMid?: string | undefined;
  amexMid?: string | undefined;
  updatedOn?: Date | undefined;
};

/** @internal */
export const WebhookDataNetworkIDUpdated$inboundSchema: z.ZodType<
  WebhookDataNetworkIDUpdated,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  visaMid: z.string().optional(),
  mastercardMid: z.string().optional(),
  discoverMid: z.string().optional(),
  amexMid: z.string().optional(),
  updatedOn: z.string().datetime({ offset: true }).transform(v => new Date(v))
    .optional(),
});
/** @internal */
export type WebhookDataNetworkIDUpdated$Outbound = {
  accountID: string;
  visaMid?: string | undefined;
  mastercardMid?: string | undefined;
  discoverMid?: string | undefined;
  amexMid?: string | undefined;
  updatedOn?: string | undefined;
};

/** @internal */
export const WebhookDataNetworkIDUpdated$outboundSchema: z.ZodType<
  WebhookDataNetworkIDUpdated$Outbound,
  z.ZodTypeDef,
  WebhookDataNetworkIDUpdated
> = z.object({
  accountID: z.string(),
  visaMid: z.string().optional(),
  mastercardMid: z.string().optional(),
  discoverMid: z.string().optional(),
  amexMid: z.string().optional(),
  updatedOn: z.date().transform(v => v.toISOString()).optional(),
});

export function webhookDataNetworkIDUpdatedToJSON(
  webhookDataNetworkIDUpdated: WebhookDataNetworkIDUpdated,
): string {
  return JSON.stringify(
    WebhookDataNetworkIDUpdated$outboundSchema.parse(
      webhookDataNetworkIDUpdated,
    ),
  );
}
export function webhookDataNetworkIDUpdatedFromJSON(
  jsonString: string,
): SafeParseResult<WebhookDataNetworkIDUpdated, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WebhookDataNetworkIDUpdated$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WebhookDataNetworkIDUpdated' from JSON`,
  );
}
